import { observer } from 'mobx-react'
import React, { forwardRef } from 'react'

import AetOwnInfo from 'todistukset-ui/src/vtj/components/order-wizard-aet-shared/AetOwnInfo.react'

import type { StepComponent } from 'todistukset-ui/src/vtj/components/order-wizard/OrderWizardStep.type'
import { useAetSignerFormActions } from 'todistukset-ui/src/vtj/stores/actions/aet-signer-form-actions'
import { useAetSignerForm } from 'todistukset-ui/src/vtj/stores/aet-signer-form.store'

const AetSignerInfoStep: StepComponent = observer(
  forwardRef(function AetOrdererInfoStep({ titleId, orderFlowName }, ref) {
    return (
      <AetOwnInfo
        useForm={useAetSignerForm}
        useFormActions={useAetSignerFormActions}
        ref={ref}
        titleId={titleId}
        orderFlowName={orderFlowName}
      />
    )
  })
)

export default AetSignerInfoStep
